module.exports = __webpack_public_path__ + "img/WhySoSad.8cfaeb16.jpg";